import styled from 'styled-components';

export const CreateAndEditAuthorContainer = styled.div``;
